
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/top-charts",
      function () {
        return require("private-next-pages/top-charts/index.js");
      }
    ]);
  